"use client";
import PropTypes from "prop-types";

import SendMessageButton from "components/common/send-message-button";
import { LazyImage } from "components/common/lazy-image/LazyImage";
import ShowPhone from "components/common/show-phone/ShowPhone";

import classNames from "classnames";
import styles from "./styles.module.css";

export const ExtraContactImage = ({ listingDetailData, image, phoneNumber, listingId }) => {
  const extraImageWrapper = classNames(styles.imageWrapper, styles.extraImageWrapper);
  return (
    <>
      <div className={styles.extraContactItem}>
        <p className={styles.contactText}>İlan için iletişime geçmek ister misin?</p>
        <div className={styles.contactButtons}>
          <div className={styles.buttonClass}>
            <SendMessageButton listingId={listingId} />
          </div>
          <div className={styles.buttonClass}>
            <ShowPhone listItemInfo={listingDetailData} phoneNumber={phoneNumber} gtmEventLabel="gallery_last_photo" />
          </div>
        </div>
      </div>
      <div className={extraImageWrapper}>
        <LazyImage src={image} alt="Picture of the author" className={styles.image} />
      </div>
    </>
  );
};

ExtraContactImage.propTypes = {
  image: PropTypes.string,
  phoneNumber: PropTypes.string,
  listingId: PropTypes.number,
  listingDetailData: PropTypes.object,
};
